$(function () { // Using "function" instead of ES6 arrow functions because your magic is no good here :.(
    // Get the full height of an element
    const getExpandedHeight = function (el) {
        const clone = el.clone().css({ display: 'block', height: 'auto', left: '20px', position: 'absolute', right: '20px', visibility: 'hidden' });
        el.closest('blockquote').append(clone);
        clone.addClass('about-sw__quote--clone');
        height = clone.outerHeight(true);
        clone.removeClass('about-sw__quote--clone');
        clone.remove();
        return height;
    };

    // Show "Read More" link if quote expanded is taller than quote collapsed
    const checkQuoteHeight = function () {
        $('.about-sw__quote--expandable').each(function () {
            const element = $(this);
            const heightExpanded = getExpandedHeight(element);
            const heightCollapsed = $(this).outerHeight(true);

            if (!(heightExpanded > heightCollapsed)) {
                $(this).css('height', 'auto');
                $(this).find('.about-sw__expand').css('display', 'none');
            } else {
                $(this).find('.about-sw__expand').css('display', 'flex');
            }
        });
    };

    checkQuoteHeight();

    // Check quote widths
    const $quote = $('.about-sw__quote--expandable');
    let quoteWidth = $quote.width();
    let quoteParentWidth = $quote.parent().outerWidth();

    const resetQuoteHeight = function () {
        $quote.removeClass('expanded').removeAttr('style');
        $('.about-sw__expand').text('Read More');
    };

    // If parent is expanded, collapse ... else expand!
    const toggleExpand = function (span, parent) {
        const heightExpanded = getExpandedHeight(parent);
        if (!parent.hasClass('expanded')) {
            parent.css('height', `${heightExpanded}px`).addClass('expanded');
            span.text('Read Less');
        } else {
            parent.css('height', '').removeClass('expanded');
            span.text('Read More');
        }
    };

    // Expand/collapse when "Read More" or "Read Less" is clicked
    $('.about-sw__expand').on('click', function () {
        const parent = $(this.parentNode);
        const el = $(this);
        toggleExpand(el, parent);
    });

    // Expand/collapse when hitting space/enter on "Read More" or "Read Less"
    $('.about-sw__expand').on('keypress', function (e) {
        const parent = $(this.parentNode);
        const el = $(this);
        if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
            e.preventDefault();
            toggleExpand(el, parent);
        }
    });

    // Reset everything on window resize
    let timeout;
    let timeoutToo;
    $(window).on('resize', function () {
        const currentWidth = $quote.width();
        $('#customerReviews').css('scroll-snap-type', 'x mandatory');
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            if (currentWidth !== quoteWidth) {
                resetQuoteHeight();
            }
        }, 250);
        clearTimeout(timeoutToo);
        timeoutToo = setTimeout(function () {
            if (currentWidth !== quoteWidth) {
                checkQuoteHeight();
            }
            quoteWidth = currentWidth;
            quoteParentWidth = $quote.parent().outerWidth();
            $('#customerReviews').css('scroll-snap-type', '');
        }, 1000);
    });

    // Control scrolling quotes on customer service page
    const sideScroll = function (element, direction, speed, distance, step) {
        let scrollAmount = 0;
        const slideTimer = setInterval(function () {
            if (direction === 'left') {
                element.scrollLeft -= step; // eslint-disable-line no-param-reassign
            } else {
                element.scrollLeft += step; // eslint-disable-line no-param-reassign
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    };

    // Scroll click handler; also enables/disables previous/next buttons (don't judge me)
    const scroller = function () {
        const scrollForward = document.getElementById('scrollQuoteForward');
        const scrollBack = document.getElementById('scrollQuoteBack');
        const reviews = document.getElementById('customerReviews');
        let numberOfReviews = 0;
        if (reviews !== null) {
            numberOfReviews = reviews.getElementsByTagName('blockquote').length;
        }
        let travelDistance = 1;

        if (scrollForward !== null) {
            scrollForward.onclick = function () {
                resetQuoteHeight();
                scrollBack.removeAttribute('disabled', '');
                travelDistance += 1;
                if (travelDistance >= numberOfReviews) {
                    scrollForward.setAttribute('disabled', '');
                    travelDistance = numberOfReviews;
                } else {
                    scrollForward.removeAttribute('disabled', '');
                }
                sideScroll(reviews, 'right', 2, quoteParentWidth, 12);
            };
        }

        if (scrollBack !== null) {
            scrollBack.onclick = function () {
                resetQuoteHeight();
                travelDistance -= 1;
                scrollForward.removeAttribute('disabled', '');
                if (travelDistance <= 1) {
                    scrollBack.setAttribute('disabled', '');
                    travelDistance = 1;
                } else {
                    scrollBack.removeAttribute('disabled', '');
                }
                sideScroll(reviews, 'left', 2, quoteParentWidth, 12);
            };
        }
    };

    scroller();
});
